class Team {
	constructor(config) {
		this.config = Object.assign({
			scope: '.team',
		}, config);

		$(document).ready(() => {
			this.$scope = $(this.config.scope);

			if (this.$scope.length > 0) {
				this.init();
			}
		});
	}

	init() {
		this.$scope.each((_, scope) => {
			this.#bindEvents(scope);
		});
	}

	#bindEvents(scope) {
		$(scope).find('.team-card.card-toggler').on('click touchend', (e) => {
			e.preventDefault();
			const $card = $(e.currentTarget);
			$card.toggleClass('show');
		});

		$(scope).find('.team-card__back .card-toggler').on('click touchend', (e) => {
			e.preventDefault();
			e.stopPropagation();
			$(e.currentTarget).closest('.team-card').removeClass('show');
		});

		$(document).on('click touchend', (e) => {
			if (!$(e.target).closest('.team-card').length) {
				$(scope).find('.team-card').removeClass('show');
			}
		});
	}
}

export default new Team;